import jwtDecode from 'jwt-decode';
import { useCallback, useMemo } from 'react';
import { useAppState } from '../hooks/useAppState';

const token_key = 'plusco-jt2025-signature';
const EXPIRATION_AGE = 86500000; // 86500000 milliseconds in a day
// local storage of token
var _encoded: string | undefined | null;
var _onTokenChange: any[] = [];
// var _override = null;

export function saveToken(t?: string | null) {
  // _override = null;
  _encoded = t;
  if (typeof t === 'string') {
    window.localStorage?.setItem(token_key, _encoded!);
  } else {
    // for clearing token only
    _encoded = undefined;
    window.localStorage && window.localStorage.removeItem(token_key);
  }
  if (_onTokenChange.length) {
    for (var callback of _onTokenChange) {
      callback(_encoded);
    }
  }
}

export function onTokenChange(callback: any) {
  _onTokenChange.push(callback);
}

export const isAuthenticated = () => {
  if (!_encoded) {
    // try local storage
    _encoded = window.localStorage && window.localStorage.getItem(token_key);
  }
  if (!!_encoded) {
    const user: any = jwtDecode(_encoded || '');
    // token expiration
    const age = new Date().getTime() - (user?.iat || 0);
    if (age > EXPIRATION_AGE) {
      saveToken(null);
      return false;
    }
  }
  return !!_encoded;
};

export const getTokenData = (): any => {
  if (isAuthenticated()) {
    return jwtDecode(_encoded || '');
  }
  return {};
};

export const getToken = () => (isAuthenticated() ? _encoded : null);

export const hasRole = (role: string) => {
  const token = getTokenData();
  return role === token?.r || role === 'any';
};

export const useAuth = () => {
  const [token, setGlobalToken] = useAppState('token', getToken());
  const setToken = useCallback((token?: string | null) => {
    saveToken(token);
    setGlobalToken(token);
    // eslint-disable-next-line
  }, []);
  const user = useMemo(() => {
    if (!isAuthenticated()) {
      return undefined;
    }
    const t = getTokenData();
    return {
      id: t.sub,
      firstname: t.f,
      lastname: t.l,
      email: t.e,
      isDev: t.e === 'jesseteal@gmail.com',
      isAdmin: t.r === 'Admin',
      isRO: t.r === 'Read-Only',
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  return { user, setToken, token };
};
